import { useTranslation } from 'react-i18next';
import { useErisUserStore } from 'src/api/eris/store/ErisUserStore';
import { useErisAuthStore } from 'src/api/eris/store/ErisAuthStore';
import useErisSecurityService from 'src/api/eris/service/ErisSecurityService';

function ErisHeader() {
  const { t } = useTranslation();

  //ERIS
  const { authenticated: erisAuthenticated } = useErisAuthStore();
  const { erisLogoutUser } = useErisSecurityService();
  const { user } = useErisUserStore();

  const handleLogout = async () => {
    await erisLogoutUser();
  };

  return (
    <div className="flex items-center justify-between bg-white py-2">
      <div className="flex items-center">
        <div>
          <img src="/HBS_logo.jpg" className="h-10" />
        </div>
      </div>
      <div>
        {erisAuthenticated && (
          <div className="flex space-x-2">
            <div>{`${t('eris.common.username')}: ${user?.name} 様`}</div>
            <button
              className="border border-gray-400 bg-gray-500 px-4 py-1 text-xs tracking-widest text-white 
             hover:bg-gray-600 active:translate-y-px active:shadow-inner"
              onClick={handleLogout}
            >
              {t('eris.common.logout')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ErisHeader;
